(function($) {
  'use strict';
  var $overlay = $('#mobile-size-sheet-overlay');
  var $sheet = $('#mobile-size-sheet');
  var $sizesContainer = $sheet.find('[data-sizes-container]');
  var $dualSizesContainer = $sheet.find('[data-dual-sizes-container]');
  var $waistOptions = $sheet.find('[data-waist-options]');
  var $inseamOptions = $sheet.find('[data-inseam-options]');
  var $colorPreview = $sheet.find('[data-color-preview]');
  var $colorSwatch = $colorPreview.find('[data-color-swatch]');
  var $colorName = $colorPreview.find('[data-color-name]');
  var $title = $sheet.find('[data-sheet-title]');
  var $errorMsg = $sheet.find('[data-error-msg]');
  var $addBtn = $sheet.find('[data-add-btn]');
  
  var selectedVariantId = null;
  var selectedWaist = null;
  var selectedInseam = null;
  var dualSizeVariants = null;
  var dualSizeWaistIndex = null;
  var dualSizeInseamIndex = null;

  $(document).ready(function() {
    bindEvents();
    if ($sheet.length) {
      $sheet.attr('aria-hidden', 'true').attr('inert', 'inert');
    }
  });

  function bindEvents() {   

    $(document).on('click', '[data-open-size-sheet]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var $trigger = $(this);
      var $productBlock = $trigger.closest('product-block');
      if (!$productBlock.length) return;

      var variantId = $trigger.data('variant-id');
      var hasSize = $productBlock.data('has-size') === 'true' || $productBlock.data('has-size') === true;
      var hasColor = $productBlock.data('has-color') === 'true' || $productBlock.data('has-color') === true;

      if (variantId && !hasSize && !hasColor) {
        addToCartImmediately(variantId, $trigger);
        return;
      }

      openSheet($productBlock);
    });

    $overlay.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeSheet();
    });

    $sheet.find('[data-close-sheet]').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeSheet();
    });

    $sheet.on('click', '[data-sizes-container] [data-size-btn]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $btn = $(this);
      
      if ($btn.hasClass('mobile-size-sheet__size-btn--unavailable') || $btn.prop('disabled')) return;
      
      var clickedVariantId = $btn.data('variant-id');
      
      $sizesContainer.find('[data-size-btn]').removeClass('mobile-size-sheet__size-btn--selected');
      $btn.addClass('mobile-size-sheet__size-btn--selected');
      
      addToCartImmediately(clickedVariantId, $btn);
    });
    
    $sheet.on('click', '[data-waist-btn]', function(e) {
      e.preventDefault();
      e.stopPropagation(); 
      var $btn = $(this);
      
      if ($btn.hasClass('mobile-size-sheet__size-btn--unavailable') || $btn.prop('disabled')) return;
      
      $waistOptions.find('[data-waist-btn]').removeClass('mobile-size-sheet__size-btn--waist-selected');
      $btn.addClass('mobile-size-sheet__size-btn--waist-selected');
      
      selectedWaist = $btn.data('waist-value');
      updateDualSizeAddButton();
    });
    
    $sheet.on('click', '[data-inseam-btn]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $btn = $(this);
      
      if ($btn.hasClass('mobile-size-sheet__size-btn--unavailable') || $btn.prop('disabled')) return;
      
      $inseamOptions.find('[data-inseam-btn]').removeClass('mobile-size-sheet__size-btn--inseam-selected');
      $btn.addClass('mobile-size-sheet__size-btn--inseam-selected');
      
      selectedInseam = $btn.data('inseam-value');
      updateDualSizeAddButton();
    });
    
    $sheet.on('click', '[data-add-btn]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!selectedWaist || !selectedInseam) return;
      
      var $btn = $(this);
      var variantId = findDualSizeVariantId(selectedWaist, selectedInseam);
      if (variantId) {
        addToCartImmediately(variantId, $btn);
      } else {
        $errorMsg.text('This combination is unavailable').show();
      }
    });

    var touchStartY = 0;
    $sheet.on('touchstart', function(e) {
      touchStartY = e.originalEvent.touches[0].clientY;
    });
    $sheet.on('touchmove', function(e) {
      var deltaY = e.originalEvent.touches[0].clientY - touchStartY;
      if (deltaY > 60) closeSheet();
    });

    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $sheet.attr('aria-hidden') === 'false') {
        closeSheet();
      }
    });
  }

  function updateDualSizeAddButton() {
    if (selectedWaist && selectedInseam) {
      var variantId = findDualSizeVariantId(selectedWaist, selectedInseam);
      if (variantId) {
        $addBtn.prop('disabled', false);
        $errorMsg.hide();
      } else {
        $addBtn.prop('disabled', true);
        $errorMsg.text('This combination is unavailable').show();
      }
    } else {
      $addBtn.prop('disabled', true);
      $errorMsg.hide();
    }
  }
  
  function findDualSizeVariantId(waist, inseam) {
    if (!dualSizeVariants || dualSizeWaistIndex === null || dualSizeInseamIndex === null) return null;
    
    var found = dualSizeVariants.find(function(v) {
      return v.options[dualSizeWaistIndex] == waist && 
             v.options[dualSizeInseamIndex] == inseam &&
             v.available;
    });
    
    return found ? found.id : null;
  }
  function addToCartImmediately(variantId, $triggerBtn) {
  if ($triggerBtn && $triggerBtn.length) {
    $triggerBtn.prop('disabled', true).addClass('mobile-size-sheet__btn--loading');
  }

  addToCart(variantId, 1, 
    function(response) {
      if ($triggerBtn && $triggerBtn.length) {
        $triggerBtn.prop('disabled', false).removeClass('mobile-size-sheet__btn--loading');
      }
      closeSheet();
    }, 
    function(error) {
      if ($triggerBtn && $triggerBtn.length) {
        $triggerBtn.prop('disabled', false).removeClass('mobile-size-sheet__btn--loading');
      }
      $errorMsg.text(error.message || 'Failed to add item').show();
    }
  );
}
  function openSheet($productBlock) {
    resetSheetState();

    var hasSize = $productBlock.data('has-size') === 'true' || $productBlock.data('has-size') === true;
    
    var productHandle = null;
    var hasKingColors = $productBlock.find('[data-type="COLOR_SWATCH"]').length > 0;
    
    if (hasKingColors) {
      var $selectedKingColor = $productBlock.find('[data-type="COLOR_SWATCH"] .lv-option-collection-item[selected]');
      if ($selectedKingColor.length) {
        productHandle = $selectedKingColor.data('handle');
        var colorTooltip = $selectedKingColor.data('tooltip-text');
        var bgStyle = $selectedKingColor.find('.lv-option-collection-swatch-inner').css('background-image');
        
        if (colorTooltip) {
          $colorPreview.show();
          $colorName.text(colorTooltip);
          if (bgStyle && bgStyle !== 'none') {
            $colorSwatch.css('--swatch-bg', bgStyle);
          }
        }
      }
    }
    
    if (!productHandle) {
      productHandle = $productBlock.data('product-handle');
    }
    
    $.getJSON('/products/' + productHandle + '.js', function(productData) {
      var productTitle = $productBlock.find('.product-block__title').text().trim() || 'Product';
      $title.text(productTitle);

      if (!hasSize && productData.variants.length === 1) {
        renderSingleVariantButton(productData.variants[0]);
      } else if (productData.variants.length > 0) {
        renderSizeButtons(productData.variants, productData.options, hasKingColors);
      } else {
        $sizesContainer.append(createMessageElement('No sizes available'));
      }
      showSheetUI();
      
    }).fail(function(xhr, status, error) {
      var fallbackData = $productBlock.data('variants-json');
      if (fallbackData && Array.isArray(fallbackData) && fallbackData.length > 0) {
        renderSizeButtons(fallbackData, [], false);
        showSheetUI();
      } else {
        showError('Could not load product variants');
        showSheetUI();
      }
    });
  }

  function renderSizeButtons(variants, productOptions, hasKingColors) {
    var sizeOptionNames = [];
    if (productOptions && Array.isArray(productOptions)) {
      productOptions.forEach(function(opt) {
        var name = opt.name.toLowerCase();
        if (name.indexOf('size') !== -1 || 
            name.indexOf('waist') !== -1 || 
            name.indexOf('inseam') !== -1 ||
            name.indexOf('length') !== -1 ||
            name.indexOf('width') !== -1) {
          sizeOptionNames.push(opt.name);
        }
      });
    }
    
    if (sizeOptionNames.length >= 2) {
      renderDualSizeUI(variants, productOptions);
      return;
    }
    
    $dualSizesContainer.hide();
    $addBtn.hide();
    $sizesContainer.show();
    
    var actualSizeIndex = hasKingColors ? 0 : 0;
    var sizesMap = {};
    
    variants.forEach(function(v) {
      var sizeValue = (v.options && v.options[actualSizeIndex]) 
        ? v.options[actualSizeIndex] 
        : (v.title || 'Default');
      
      if (!sizesMap[sizeValue]) {
        sizesMap[sizeValue] = { available: v.available, variantId: v.id, debugName: v.name };
      } else if (v.available && !sizesMap[sizeValue].available) {
        sizesMap[sizeValue].available = true;
        sizesMap[sizeValue].variantId = v.id;
      }
    });
    
    renderSingleSizeButtons(sizesMap);
  }

  function renderDualSizeUI(variants, productOptions) {
    $dualSizesContainer.show();
    $addBtn.show().prop('disabled', true);
    $sizesContainer.hide().empty();
    
    var waistIndex = -1;
    var inseamIndex = -1;
    
    productOptions.forEach(function(opt, idx) {
      var name = opt.name.toLowerCase();
      if (name.indexOf('waist') !== -1 || name.indexOf('size') !== -1) waistIndex = idx;
      if (name.indexOf('inseam') !== -1 || name.indexOf('length') !== -1) inseamIndex = idx;
    });
    
    if (waistIndex === -1) waistIndex = 0;
    if (inseamIndex === -1) inseamIndex = 1;
    
    var waistValues = {};
    var inseamValues = {};
    
    variants.forEach(function(v) {
      var waist = v.options[waistIndex] || '';
      var inseam = v.options[inseamIndex] || '';
      
      if (waist && !waistValues[waist]) waistValues[waist] = { available: false };
      if (inseam && !inseamValues[inseam]) inseamValues[inseam] = { available: false };
      
      if (v.available) {
        if (waistValues[waist]) waistValues[waist].available = true;
        if (inseamValues[inseam]) inseamValues[inseam].available = true;
      }
    });
    
    $waistOptions.empty();
    Object.keys(waistValues).sort(function(a, b) { 
      return (parseInt(a) || 0) - (parseInt(b) || 0); 
    }).forEach(function(waist) {
      var data = waistValues[waist];
      var $btn = $('<button>', {
        type: 'button',
        class: 'mobile-size-sheet__size-btn' + (!data.available ? ' mobile-size-sheet__size-btn--unavailable' : ''),
        'data-waist-btn': true,
        'data-waist-value': waist,
        text: waist
      });
      if (!data.available) $btn.prop('disabled', true).attr('title', 'Unavailable');
      $waistOptions.append($btn);
    });
    
    $inseamOptions.empty();
    Object.keys(inseamValues).sort(function(a, b) { 
      return (parseInt(a) || 0) - (parseInt(b) || 0); 
    }).forEach(function(inseam) {
      var data = inseamValues[inseam];
      var $btn = $('<button>', {
        type: 'button',
        class: 'mobile-size-sheet__size-btn' + (!data.available ? ' mobile-size-sheet__size-btn--unavailable' : ''),
        'data-inseam-btn': true,
        'data-inseam-value': inseam,
        text: inseam
      });
      if (!data.available) $btn.prop('disabled', true).attr('title', 'Unavailable');
      $inseamOptions.append($btn);
    });
    
    dualSizeVariants = variants;
    dualSizeWaistIndex = waistIndex;
    dualSizeInseamIndex = inseamIndex;
    
    selectedWaist = null;
    selectedInseam = null;
  }
  
  function renderSingleSizeButtons(sizesMap) {
    if (Object.keys(sizesMap).length === 0) {
      $sizesContainer.append(createMessageElement('No sizes available'));
      return;
    }
    
    $.each(sizesMap, function(sizeLabel, data) {
      var btnClass = 'mobile-size-sheet__size-btn';
      if (!data.available) btnClass += ' mobile-size-sheet__size-btn--unavailable';
      
      var $btn = $('<button>', {
        type: 'button',
        class: btnClass,
        'data-size-btn': true,
        'data-variant-id': data.variantId,
        text: sizeLabel,
        'title': data.debugName || ''
      });
      
      if (!data.available) $btn.prop('disabled', true).attr('title', 'Unavailable');
      $sizesContainer.append($btn);
    });
  }
  
  function renderSingleVariantButton(variant) {
    var $btn = $('<button>', {
      type: 'button',
      class: 'mobile-size-sheet__size-btn',
      'data-size-btn': true,
      'data-variant-id': variant.id,
      text: 'Add to Cart'
    });
    if (!variant.available) {
      $btn.addClass('mobile-size-sheet__size-btn--unavailable').prop('disabled', true).attr('title', 'Unavailable');
    }
    $sizesContainer.append($btn);
  }

  function resetSheetState() {
    $sizesContainer.empty();
    $waistOptions.empty();
    $inseamOptions.empty();
    $errorMsg.hide();
    $colorPreview.hide();
    $colorSwatch.css('--swatch-bg', 'none');
    $colorName.text('');
    
    selectedVariantId = null;
    selectedWaist = null;
    selectedInseam = null;
    dualSizeVariants = null;
    dualSizeWaistIndex = null;
    dualSizeInseamIndex = null;
    
    $addBtn.prop('disabled', true).hide();
    $dualSizesContainer.hide();
    $sizesContainer.show();
  }

  function showSheetUI() {
    $overlay.addClass('is-open');
    $sheet.addClass('is-open').attr('aria-hidden', 'false').removeAttr('inert');
    $('body').addClass('sheet-open-no-scroll');
  }

  function closeSheet() {
    $overlay.removeClass('is-open');
    $sheet.removeClass('is-open').attr('aria-hidden', 'true').attr('inert', 'inert');
    $('body').removeClass('sheet-open-no-scroll');
  }

  function showError(msg) {
    $errorMsg.text(msg).show();
    $sizesContainer.empty();
  }

  function createMessageElement(text) {
    return $('<p>', { class: 'mobile-size-sheet__message', text: text });
  }

  function addToCart(variantId, qty, successCallback, errorCallback) {
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ id: variantId, quantity: qty || 1 }),
      success: function(response) {
        if (response && response.status === 'error') {
          errorCallback(response);
        } else {
          if (response && response.item_count !== undefined) {
            $('.cart-count, .header__cart-count, [data-cart-count]').text(response.item_count);
            $('.cart-link, .header__cart').attr('aria-label', 'Cart: ' + response.item_count + ' items');
          }
          
          var cartDrawer = document.querySelector('.js-cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true }));
          }
          
          document.dispatchEvent(new CustomEvent('abra:cart:changed', { 
            bubbles: true, 
            cancelable: false,
            detail: { cart: response } 
          }));
          document.dispatchEvent(new CustomEvent('on:cart:change', { 
            bubbles: true,
            detail: { cart: response }
          }));
          
          successCallback(response);
        }
      },
      error: function(xhr, status, error) {
        errorCallback({ message: error || 'Network request failed' });
      }
    });
  }

})(jQuery);